// extracted by mini-css-extract-plugin
module.exports = {"container":"IWrnmXX9FhxMKaaRNSD97","valueItem":"_7mrcpdFFdEBNn8CIukzZp","deleteBtn":"oF4WBfQ5uQfBMzMtb_gJe","deleteIcon":"_3rWTVlMuEC6oawbhcaKyGS"};